import useQuery from '@cbgms/base/http/use-query'
import { useDispatch } from 'react-redux'
import { getAzureRedirectURI } from '../state/actions'
import { azureRedirectUriCacheKey } from './cache-keys'
import { useLocation } from 'react-router-dom'

export const useGetAzureRedirectURI = (onSuccess?: (data: string) => void) => {
  const dispatch = useDispatch()
  const location = useLocation()

  return useQuery(
    azureRedirectUriCacheKey(),
    async () => {
      const host = window.location.host
      const { Data } = await dispatch(getAzureRedirectURI())
      const url = Data.URL

      const redirectUri = `https://${host}/auth/login`

      // using state instead of adding query params to redirect_uri
      const { pathname, search } = location
      const searchParams = new URLSearchParams(search)
      const redirectPath = pathname + search || searchParams.get('redirect') || '/'
      const state = encodeURIComponent(btoa(JSON.stringify({ redirect: redirectPath })))
      // Only set redirect_uri , as this is the only one used by Azure and attach rest in state
      const redirectURI = url.replace('{redirect_uri}', encodeURIComponent(redirectUri)).concat(`&state=${state}`)
      return redirectURI
    },
    { onSuccess, refetchOnWindowFocus: false }
  )
}
